import PropTypes from 'prop-types';
import DataCacheService from '@/shared/services/DataCacheService';

export const hasMultipleCompanies = () => {
  const dataCache = DataCacheService.getDataCache();
  if (!dataCache) return false;
  const companies = dataCache.company;
  return !!companies && companies.length > 1;
};

const HasMultiCompany = ({ children = null, fallback = null }) => {
  if (!children) return null;
  if (!hasMultipleCompanies()) return fallback;
  return children;
};

HasMultiCompany.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.node,
};
export default HasMultiCompany;
